import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import api from "../../services/api";
import * as S from "./styled";

import { toast } from "react-toastify";

import { useAuth } from "../../context/auth";

import Logo from "../../assets/logo_pagina_login.png";

// Mesma regex usada no backend (src/utils/validators.ts)
const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

function Login() {
  const [login, setLogin] = useState("");
  const [pass, setPass] = useState("");
  const [aviso, setAviso] = useState(false);
  const [recuperar, setRecuperar] = useState(false);
  const [enviado, setEnviado] = useState();

  const [novoEmail, setNovoEmail] = useState("");
  const [enviando, setEnviando] = useState(false);
  const [verificando, setVerificando] = useState(true);

  const history = useHistory();

  const { user, setUser } = useAuth();

  async function loginHandler(e) {
    e.preventDefault();

    const dataLogin = {
      user: login,
      password: pass,
    };

    try {
      let response = await api.post("/login", dataLogin);

      /* informação completa do login, incluindo token e dados do usuário importante nao exibir isso no console 
      em produção, mas eh útil para debug durante o desenvolvimento 
        console.log('Resposta do login:', response.data); 
        console.log('Dados do usuário no login:', response.data.user);
      */

      setUser({
        nome: response.data.user.name,
        nivel: response.data.user.type,
        id: response.data.user.id,
        turma: response.data.user.turma_id,
        plano: response.data.user.plan,
        comprou_ebook: response.data.user.comprou_ebook || false,
        data_limite: response.data.user.data_limite
      });

      if (response.data.message === "Auth Successful") {
        toast(
          "Seja bem vindo(a)! Você esta sendo redirecionado para a página inicial"
        );
        localStorage.setItem("token", response.data.token);

        setTimeout(() => {
          history.push("/logado");
        }, 1 * 1000);
      }
    } catch (err) {
      toast.error("Email ou senha estão incorretos.");
      localStorage.removeItem("token");
    }
  }

  const MSG_SUCESSO =
    "Sua nova senha foi enviada para o e-mail cadastrado. Você já pode fazer o login com ela.";

  function abrirRecuperacao() {
    setRecuperar(true);
    setAviso(false);
    setEnviado(undefined);
  }

  function fecharRecuperacao() {
    setRecuperar(false);
    setNovoEmail("");
    setAviso(false);
  }

  async function novaSenha(e) {
    e.preventDefault();

    const emailInformado = novoEmail.trim();

    // Mesma regra do backend: recuperação é só por e-mail, CPF não vale.
    if (!EMAIL_REGEX.test(emailInformado)) {
      setAviso("Digite um e-mail válido.");
      return;
    }

    setEnviando(true);
    setAviso(false);

    try {
      const response = await api.post("/recuperarSenha", {
        email: emailInformado,
      });

      // 204: nenhum usuário com esse e-mail (resposta sem corpo).
      if (response.status === 204) {
        toast.error("E-mail não encontrado.");
        setAviso("E-mail não encontrado.");
        return;
      }

      toast.success(MSG_SUCESSO);
      setEnviado(MSG_SUCESSO);
      setNovoEmail("");
      setRecuperar(false);
    } catch (err) {
      /*
        400 = e-mail em formato inválido (a validação acima já barra, é defesa extra).
        502 = o envio falhou no provedor; a senha antiga continua valendo, então
              pedir para tentar de novo é seguro (o backend só grava a senha nova
              depois que o e-mail sai).
      */
      const status = err.response?.status;

      const mensagem =
        status === 400
          ? "Digite um e-mail válido."
          : status === 502
          ? "Não conseguimos enviar o e-mail agora. Tente novamente em alguns minutos."
          : "Não foi possível recuperar a senha. Tente novamente.";

      toast.error(mensagem);
      setAviso(mensagem);
    } finally {
      setEnviando(false);
    }
  }

  useEffect(() => {
    if (user.id > 0) {
      history.push("/logado");
    } else {
      setVerificando(false);
    }
  }, []);

  if (verificando) return null;

  return (
    <S.LoginWrapper>
      <img src={Logo} alt="Curso Danielle Velascos - Login" />

      {/*
        O card tem dois modos: login e recuperação de senha. Um substitui o outro
        no lugar, em vez de empilhar os dois formulários.
      */}
      <S.FromWrapper>
        <h1>{recuperar ? "Recuperar senha" : "Login"}</h1>

        {recuperar ? (
          <S.RecoverForm>
            <S.RecoverHint>
              Informe o e-mail do seu cadastro. Enviaremos uma nova senha de
              acesso para ele.
            </S.RecoverHint>

            {/*
              onSubmit (em vez de onClick no botão) para o Enter também funcionar.
              noValidate desliga o balão nativo do browser: o type="email" fica só
              pelo teclado do celular, e a validação/mensagem é a nossa.
            */}
            <form onSubmit={novaSenha} noValidate>
              <S.InputGroup>
                <label>E-mail cadastrado</label>
                <input
                  type="email"
                  placeholder="Digite seu e-mail"
                  value={novoEmail}
                  onChange={(e) => setNovoEmail(e.target.value)}
                  disabled={enviando}
                  autoFocus
                />
              </S.InputGroup>
              <S.RecoverButton type="submit" disabled={enviando}>
                {enviando ? "Enviando..." : "Enviar nova senha"}
              </S.RecoverButton>
              <S.CancelButton
                type="button"
                onClick={fecharRecuperacao}
                disabled={enviando}
              >
                Voltar para o login
              </S.CancelButton>
            </form>
          </S.RecoverForm>
        ) : (
          <>
            <form>
              <S.InputGroup>
                <label>E-mail / CPF</label>
                <input
                  placeholder="Digite seu e-mail ou CPF"
                  value={login}
                  onChange={(e) => setLogin(e.target.value)}
                />
              </S.InputGroup>
              <S.InputGroup>
                <label>Senha</label>
                <input
                  placeholder="Digite sua senha"
                  type="password"
                  onChange={(e) => setPass(e.target.value)}
                />
              </S.InputGroup>
              <S.LoginButton onClick={loginHandler}>Entrar</S.LoginButton>
            </form>

            <S.Divider>
              <span>ou</span>
            </S.Divider>

            <S.RecoverText>
              Não lembra sua senha?{" "}
              <strong onClick={abrirRecuperacao}>RECUPERAR SENHA</strong>
            </S.RecoverText>
          </>
        )}

        {aviso && <S.Aviso>{aviso}</S.Aviso>}

        {enviado && (
          <S.SuccessMessage>
            <strong>✅ Nova senha enviada com sucesso!</strong>
            Tente fazer o login com sua nova senha.
          </S.SuccessMessage>
        )}
      </S.FromWrapper>
    </S.LoginWrapper>
  );
}

export default Login;
